<template>
  <tr>
    <td :class="'text-xs-left'" :width="width.toString() + '%'">
      <template v-if="name != null">
        <template v-if="heading == 'h1'">
          <h1>{{ name }}</h1>
        </template>
        <template v-if="heading == 'h2'">
          <h2>{{ name }}</h2>
        </template>
        <template v-if="heading == 'h3'">
          <h3>{{ name }}</h3>
        </template>
        <template v-if="heading == 'h4'">
          <h4>{{ name }}</h4>
        </template>
        <template v-if="heading == 'h5'">
          <h5>{{ name }}</h5>
        </template>
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  name: "AdvancedCoreHeader",
  props: {
    name: {
      type: String,
      require: false,
      default: null,
    },
    heading: {
      type: String,
      require: false,
      default: "h3",
    },
    width: {
      type: Number,
      require: false,
      default: 50,
    },
  },
};
</script>

<style scoped></style>
